<template>
  <div class="desktop-layout">
    <div v-if="fooldalData">
      <swiper-container class="relative" :options="vezerhirSwiperOptions">
        <div class="swiper-slide" v-for="hir in vezerhir" :key="hir.Id">
          <v-card
            class="vezerhir mb-5"
            :to="{
              name: 'Hir',
              params: {
                id: hir.Azonosito,
              },
            }"
          >
            <v-img height="450px" :src="hir.Kep + '?h=450'">
              <v-app-bar flat color="rgba(0, 0, 0, 0)">
                <v-spacer></v-spacer>
                <k-fontos-hir-icon
                  class="mr-0 mt-5"
                  color="primary"
                  :hir="hir"
                ></k-fontos-hir-icon>
              </v-app-bar>
              <div class="vezerhir-bottom">
                <div class="vezerhir-bottom-bg">
                  <p
                    class="white--text mb-2"
                    v-html="hir.Kategoriak.map(m => m.Nev).join(', ')"
                  ></p>
                  <h3 class="white--text mb-2">
                    {{ hir.Cim }}
                  </h3>
                  <p class="white--text hirismerteto">
                    {{ vezerhir.Ismerteto }}
                  </p>
                  <div class="d-inline-flex">
                    <v-img
                      :src="
                        hir.Szerzo.Kep
                          ? hir.Szerzo.Kep + '?w=32&h=32'
                          : $placeholderImage
                      "
                      height="32px"
                      max-height="32px"
                      width="32px"
                      max-width="32px"
                      class="rounded"
                    >
                    </v-img>
                    <p class="mb-0 white--text d-flex align-center">
                      <span class="dot-separator white mx-2"></span>
                      {{ hir.Szerzo.Nev }}
                      <span class="dot-separator white mx-2"></span>
                      <k-live-timestamp
                        :value="hir.MegjelenesDatuma"
                      ></k-live-timestamp>
                    </p>
                  </div>
                </div>
              </div>
            </v-img>
          </v-card>
        </div>
      </swiper-container>
      <v-container class="pa-0 mt-10" fluid>
        <v-row>
          <v-col md="3">
            <h3 class="sidebar-header">
              <span>{{ nyelvesites['kereses_text'] }}</span>
            </h3>
            <div class="sidebar-section d-flex">
              <v-text-field
                v-model="searchText"
                flat
                solo
                hide-details
                :placeholder="nyelvesites['kereses_placeholder_text']"
                class="br-0 elevation-0"
                height="46"
                @click:append="Kereses"
                @keyup.enter="Kereses"
              ></v-text-field>
              <v-btn
                color="#292929"
                @click="Kereses"
                dark
                height="48"
                class="br-0"
              >
                {{ nyelvesites['mehet_text'] }}
              </v-btn>
            </div>
            <div v-if="linkek.length > 0" class="sidebar-section">
              <h3 class="sidebar-header" v-for="link in linkek" :key="link.Id">
                <span>
                  <router-link
                    v-if="link.Cikk"
                    class="kiemelt-link"
                    :to="{
                      name: 'Hir',
                      params: {
                        id: link.Cikk.Azonosito,
                      },
                    }"
                  >
                    {{ link.Nev }}
                  </router-link>
                  <a class="kiemelt-link" :href="link.Url" v-else>
                    {{ link.Nev }}
                  </a>
                </span>
              </h3>
            </div>
            <div v-if="isEsemenyNaptarVisible">
              <h3 class="sidebar-header">
                Eseménynaptár
              </h3>
              <div class="sidebar-section">
                <k-event-calendar></k-event-calendar>
              </div>
            </div>
            <template v-for="kiemelt in kiemeltKategoriak">
              <h3 class="sidebar-header" :key="`h_${kiemelt.Id}`">
                <router-link
                  :to="{
                    name: 'KiemeltKategoria',
                    params: { id: kiemelt.Id },
                  }"
                >
                  <span>{{ kiemelt.Nev }}</span>
                </router-link>
              </h3>
              <div class="sidebar-section" :key="`d_${kiemelt.Id}`">
                <router-link
                  v-for="alkategoria in kiemelt.Kategoria"
                  :key="alkategoria.Id"
                  class="flex-center-between flex-wrap font-size-md mb-2 alkategoria-link"
                  :class="{
                    active: alkategoria.Id == $route.query.alkategoriaId,
                  }"
                  exact
                  replace
                  :to="{
                    name: 'KiemeltKategoria',
                    params: { id: kiemelt.Id },
                    query: { alKategoriaId: alkategoria.Id },
                  }"
                >
                  <div class="d-flex align-center">
                    {{ alkategoria.Nev }}
                    <!-- <i class="fas fa-angle-double-right ml-1"></i> -->
                    <span class="double-arrow-fake-icon">>></span>
                  </div>
                </router-link>
              </div>
            </template>
            <template v-if="aktualisProjekt.SokanOlvastakFl">
              <h3 class="sidebar-header">
                <router-link :to="{ name: 'NepszeruHirek' }">
                  <span>{{ nyelvesites['nepszeru_cikkek_text'] }}</span>
                </router-link>
              </h3>
              <div class="sidebar-section" v-if="fooldalData.nepszeruHirek">
                <div
                  v-for="hir in fooldalData.nepszeruHirek.Hirek"
                  :key="hir.Id"
                  class="d-flex mb-7"
                >
                  <div class="pr-3">
                    <v-img
                      width="102"
                      height="87"
                      :src="hir.Kep + '?h=450'"
                    ></v-img>
                  </div>
                  <div>
                    <router-link
                      class="grey--text text--darken-2 font-size-lg"
                      :to="{
                        name: 'Hir',
                        params: {
                          id: hir.Azonosito,
                        },
                      }"
                    >
                      <div class="text-truncate-two-line font-size-md">
                        {{ hir.Cim }}
                      </div>
                    </router-link>
                    <div class="font-size-md">
                      {{ hir.MegjelenesDatuma | toShortDate }}
                    </div>
                  </div>
                </div>
              </div>
            </template>
            <template v-if="aktualisProjekt.YoutubeFl">
              <h3 class="sidebar-header">
                <router-link :to="{ name: 'YoutubeVideok' }">
                  <span>YouTube</span>
                </router-link>
              </h3>
              <div class="sidebar-section yt-videok relative mb-13">
                <swiper-container :options="youtubeVideokSwiperOptions">
                  <div
                    class="swiper-slide"
                    v-for="video in getTopYoutubeVideok"
                    :key="video.Id"
                  >
                    <v-card class="mb-3" @click="OpenYoutubeVideoModal(video)">
                      <v-img :src="video.Thumbnail || $placeholderImage">
                        <template v-slot:placeholder>
                          <v-row
                            class="fill-height ma-0"
                            align="center"
                            justify="center"
                          >
                            <v-progress-circular
                              indeterminate
                              color="primary"
                            ></v-progress-circular>
                          </v-row>
                        </template>
                      </v-img>
                      <div class="yt-stats">
                        <div class="views">
                          <i class="fas fa-eye mr-1"></i>
                          {{ video.StatisticsViews }}
                        </div>
                        <div class="rating">
                          <i class="fas fa-star mr-1"></i>
                          {{ video.StarRating.Count }}
                        </div>
                      </div>
                    </v-card>
                    <h3 class="primary--text mb-1 text-truncate-hir">
                      <span class="line-clamp">{{ video.Title }}</span>
                    </h3>
                    <p
                      class="grey--text text--darken-2 d-flex align-center flex-wrap mb-0"
                    >
                      {{ video.Published | toShortDate }}
                    </p>
                  </div>
                </swiper-container>
                <div class="swiper-pagination"></div>
              </div>
            </template>
            <template
              v-if="
                aktivSzerzokSorrendezve.length > 0 &&
                  aktualisProjekt.AktivSzerzokFl
              "
            >
              <h3 class="sidebar-header">
                <router-link :to="{ name: 'Szerzok' }">
                  <span>{{ nyelvesites['aktiv_szerzok_text'] }}</span>
                </router-link>
              </h3>
              <div class="sidebar-section chip-container">
                <v-chip
                  label
                  :color="szerzo.Id == $route.query.szerzoId ? 'info' : 'black'"
                  v-for="szerzo in aktivSzerzokSorrendezve"
                  :key="szerzo.Id"
                  dark
                  :to="{ name: 'Szerzok', params: { id: szerzo.Id } }"
                >
                  {{ szerzo.Nev }}
                </v-chip>
              </div>
            </template>
          </v-col>
          <v-col md="9" class="hirek-container relative">
            <div class="hirek-container-top"></div>
            <div class="pl-2" v-if="hirekFrissitese">
              <v-row>
                <v-col md="6" sm="12" v-for="n in 8" :key="n">
                  <v-skeleton-loader type="card" class="skeleton-hir-card">
                  </v-skeleton-loader>
                </v-col>
              </v-row>
            </div>
            <div class="pl-2" v-else>
              <v-row v-if="fooldalData.topHirek">
                <v-col
                  md="6"
                  sm="12"
                  v-for="hir in fooldalData.topHirek.Hirek"
                  :key="hir.Id"
                >
                  <v-card
                    class="mx-auto hir-card"
                    elevation="3"
                    :to="{
                      name: 'Hir',
                      params: {
                        id: hir.Azonosito,
                      },
                    }"
                  >
                    <v-img
                      height="270"
                      width="100%"
                      :src="hir.Kep + '?h=450'"
                      t
                    ></v-img>
                    <k-fontos-hir-icon
                      class="mr-3 mt-3 fav-btn absolute-top-right"
                      color="primary"
                      :hir="hir"
                    ></k-fontos-hir-icon>
                    <v-card-title class="pb-0">
                      <div class="text-truncate">
                        {{ hir.Cim }}
                      </div>
                    </v-card-title>
                    <v-card-text class="pb-0">
                      <div>
                        <div
                          class="my-2 font-size-md text-truncate font-size-sm"
                        >
                          <i class="fas fa-calendar-alt fa-fw"></i>
                          <span>
                            {{ hir.MegjelenesDatuma | toShortDate }}
                          </span>

                          <i class="fas fa-user fa-fw"></i>
                          <span>
                            {{ hir.Szerzo.Nev }}
                          </span>
                        </div>
                        <div class="ismerteto-wrapper">
                          {{ hir.Ismerteto }}
                        </div>
                      </div>
                    </v-card-text>

                    <v-card-actions class="pa-3">
                      <router-link
                        class="grey--text text--darken-2 font-size-lg"
                        :to="{
                          name: 'Hir',
                          params: {
                            id: hir.Azonosito,
                          },
                        }"
                      >
                        {{ nyelvesites['tovabb_text'] }} >
                      </router-link>
                    </v-card-actions>
                  </v-card>
                </v-col>
              </v-row>
            </div>
            <div v-if="fooldalData.topHirek.Hirek.length == 0">
              <v-row>
                <v-col>
                  <k-nodata-info class="mt-15">
                    <template v-slot:icon>
                      <i class="fas fa-clipboard-list"></i>
                    </template>
                    <template v-slot:text>
                      {{ nyelvesites['nincs_cikk_hirfolyam_text'] }}
                    </template>
                  </k-nodata-info>
                </v-col>
              </v-row>
            </div>
          </v-col>
        </v-row>
        <v-row class="mt-10 mb-15">
          <v-col cols="12" class="text-center">
            <v-pagination
              :length="osszOldalSzam"
              :total-visible="6"
              v-model="oldal"
            ></v-pagination>
          </v-col>
        </v-row>
      </v-container>
    </div>
    <v-container v-else>
      <k-fooldal-desktop-skeleton></k-fooldal-desktop-skeleton>
    </v-container>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { AppFunctions } from '../../../functions/AppFunctions';
import { AppStoreTypes } from '../../../store/modules/app';
import { modalHandler } from '../../../utils/vue/modalHandler';
import { useWindow } from '../../../utils/vue/useWindow';
import pick from 'lodash/pick';
import { getMaxPages, isInViewport } from '../../../utils/common';
import settings from '../../../settings';
import { NotificationFunctions } from '../../../functions/NotificationFunctions';
import { hirService } from '../../../services/HirService';
import cloneDeep from 'lodash/cloneDeep';
import { eventBus } from '../../../main';

export default {
  name: 'fooldal-desktop-layout',
  data() {
    return {
      vezerhirSwiperOptions: {
        spaceBetween: 20,
        speed: 400,
        watchOverflow: true,
        autoplay: {
          delay: 8000,
          reverseDirection: true,
        },
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
      },
      szerzokSwiperOptions: {
        spaceBetween: 20,
        speed: 400,
        freeMode: true,
        freeModeSticky: true,
        slidesPerView: 'auto',
        watchOverflow: true,
      },
      adatokBetoltese: false,
      hirekFrissitese: false,
      searchText: '',
      isActive: true,
    };
  },
  setup() {
    let { windowSize } = useWindow();
    return { windowSize };
  },
  mounted() {
    this.GetFooldalAdatok();
  },
  activated() {
    this.isActive = true;
    this.GetFooldalAdatok();
  },
  deactivated() {
    this.isActive = false;
  },
  created() {
    eventBus.$on('after-login', this.HirekBetoltese);
  },
  beforeDestroy() {
    eventBus.$off('after-login', this.HirekBetoltese);
  },
  methods: {
    OpenYoutubeVideoModal(video) {
      modalHandler.OpenModal('youtube-video-modal', video);
    },
    async GetFooldalAdatok() {
      if (this.adatokBetoltese) {
        return;
      }
      this.adatokBetoltese = true;
      try {
        await AppFunctions.GetFooldalDesktopAdatok(this.keresoParameterek);
      } catch (error) {
        console.log(error);
      }
      this.adatokBetoltese = false;
    },
    async HirekBetoltese() {
      this.hirekFrissitese = true;
      let el = document.getElementsByClassName('hirek-container-top')[0];
      await this.$nextTick();
      if (el && !isInViewport(el)) {
        el.scrollIntoView({
          behavior: 'smooth',
        });
      }
      try {
        let keresoParameterek = this.keresoParameterek;
        let hirek = await hirService.GetHirekLapozhato({
          kategoriaId: keresoParameterek.alkategoriaId,
          szerzoId: keresoParameterek.szerzoId,
          oldal: keresoParameterek.oldal,
        });
        let data = cloneDeep(this.fooldalData);
        data.topHirek = hirek;
        this.$store.dispatch(AppStoreTypes.fooldalDataDesktop.set, {
          value: data,
        });
      } catch (error) {
        NotificationFunctions.AjaxError({ error });
      }
      this.hirekFrissitese = false;
    },
    GetSzerzoLink(szerzoId) {
      if (this.$route.query.szerzoId != szerzoId) {
        return {
          name: 'Fooldal',
          query: {
            szerzoId: szerzoId,
          },
        };
      } else {
        return {
          name: 'Fooldal',
        };
      }
    },
    Kereses() {
      this.$router.push({ name: 'Kereses', query: { text: this.searchText } });
      this.searchText = '';
    },
    GetRovatLink(alkategoriaId) {
      if (this.$route.query.alkategoriaId != alkategoriaId) {
        return {
          name: 'Fooldal',
          query: {
            alkategoriaId: alkategoriaId,
          },
        };
      } else {
        return {
          name: 'Fooldal',
        };
      }
    },
  },
  computed: {
    ...mapGetters({
      fooldalData: AppStoreTypes.fooldalDataDesktop.get,
      hirKategoriak: AppStoreTypes.hirKategoriak.getAll,
      user: AppStoreTypes.user.get,
      linkek: AppStoreTypes.linkek.getAll,
    }),
    aktualisProjekt() {
      return this.user?.Projekt;
    },
    vezerhir() {
      return this.fooldalData?.vezerHir;
    },
    getAlkategoriak() {
      return AppFunctions.GetAlkategoriakFromKategoriak(this.hirKategoriak);
    },
    aktivSzerzokSorrendezve() {
      return AppFunctions.SortSzerzok(this.fooldalData.aktivSzerzok, this.user);
    },
    youtubeVideokSwiperOptions() {
      return {
        spaceBetween: 20,
        speed: 400,
        freeMode: false,
        slidesPerView: 1,
        watchOverflow: true,
        pagination: {
          el: '.swiper-pagination',
          type: 'bullets',
          bulletElement: 'span',
        },
      };
    },
    kiemeltKategoriak() {
      return this.hirKategoriak.filter(f => f.Kiemelt);
    },
    isMobile() {
      return this.$vuetify.breakpoint.smAndDown;
    },
    getMiniVezerhirek() {
      return this.fooldalData?.vezerHir.slice(1, 5);
    },
    oldal: {
      get() {
        return parseInt(this.$route.query.oldal ?? 1, 10);
      },
      set(v) {
        this.$router.replace({
          name: 'Fooldal',
          query: {
            ...this.$route.query,
            oldal: v,
          },
        });
        console.log(v);
      },
    },
    keresoParameterek() {
      return pick(this.$route.query, [
        'oldal',
        'szerzoId',
        'kategoriaId',
        'alkategoriaId',
      ]);
    },
    osszOldalSzam() {
      let max = this.fooldalData?.topHirek?.Osszesen ?? 0;
      return getMaxPages(max, settings.perPagePaginated);
    },
    getTopYoutubeVideok() {
      return this.fooldalData.youtubeVideok.slice(0, 5);
    },
    nyelvesites() {
      return AppFunctions.GetNyelvesitesDict(this.user?.Projekt.Nyelvesites);
    },
    isEsemenyNaptarVisible() {
      return this.aktualisProjekt.EsemenynaptarFl;
    },
  },
  watch: {
    keresoParameterek: {
      handler() {
        if (!this.isActive) {
          return;
        }
        this.HirekBetoltese();
      },
      deep: true,
    },
  },
  components: {},
};
</script>
